import React, { useEffect, useRef, useState, useContext } from 'react'
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';

import Card from '../../../Components/Card/Card';
import AgGrid from '../../../Components/Tables/AgGrid/AgGrid';
import Icon from '../../../Components/icon/Icon';
import { getLabel } from '../../../Services/Language/LanguageService';
import { baseLang } from '../../../Lang/BaseLang';
import { ConfigContext } from '../../../Context/ConfigContext/ConfigContext';
import { AuthContext } from '../../../Context/AuthContext/AuthContext';
import { setTitlePage } from '../../../Services/Config/ConfigService';

import { getAccesosWebUser } from '../../../API/IT/Accesos/AccesosRequests';
import AccesosUsersCrud from './AccesosCrud/AccesosCrud';
import AccesosUser from './AccesosCrud/AccesosUser';

const AccesosScreen = () => {
    const toast = useRef(null);
    const { config } = useContext(ConfigContext);
    const { userAuth } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [Accesos, setAccesos] = useState([]);
    const [selected, setSelected] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [showDialogUser, setShowDialogUser] = useState(false);

    const getInfo = async () => {
      setLoading(true);
      const d = await getAccesosWebUser();
      // console.log(d);
      setAccesos(d);
      setLoading(false);
    };

    const columns = [
      {
        header: "ID",
        headerEn: "ID",
        field: "IdAccess",
        hidden: userAuth.IdRol === 1,
        className: "colum-width-Xsmall",
        onCellDoubleClicked: ({ data }) => {
          setShowDialog(true);
          setSelected(data);
        },
      },
      {
        field: "Access",
        header: "Accesos",
        headerEn: "Access",
        className: "XXXlarge",
        // flex: 1,
        minWidth: 400,
        onCellDoubleClicked: ({ data }) => {
          setShowDialog(true);
          setSelected(data);
        },
      },
      {
        header: "Descripción",
        headerEn: "Description",
        field: "Descripcion",
        className: "XXXlarge",
      },
      {
        header: "Id Menú",
        headerEn: "Menu Id",
        field: "IdMenu",
        className: "Xsmall",
      },
      {
        field: "Menu",
        header: "Menú",
        headerEn: "Menu",
        className: "colum-width-medium",
      },
      {
        field: "Icon",
        header: "Icono",
        headerEn: "Icon",
        className: "colum-width-medium",
        body: (rowData) => <Icon icon={rowData.Icon ? rowData.Icon : "a"} />,
        align: "center",
        Format: "Icon",
      },
      {
        field: "URL",
        header: "URL",
        headerEn: "URL",
        className: "colum-width-medium",
      },
      {
        field: "Activeweb",
        header: "Web",
        headerEn: "Web",
        className: "Xsmall",
        Format: "Template",
        align: "center",
        filter: false,
        body: (rowData) =>
          rowData?.IdAccess && (
            <Checkbox style={{ marginBottom: 5 }} checked={rowData.Activeweb} />
          ),
      },
      {
        field: "ActiveApp",
        header: "App",
        headerEn: "App",
        className: "Xsmall",
        Format: "Template",
        align: "center",
        filter: false,
        body: (rowData) =>
          rowData?.IdAccess && (
            <Checkbox style={{ marginBottom: 5 }} checked={rowData.ActiveApp} />
          ),
      },
      {
        field: "IdAccess",
        className: "small",
        header: "",
        Format: "Botones",
        filter: false,
        frozen: true,
        alignFrozen: "right",
        Botones: [
          {
            icon: "pi pi-pencil",
            tooltip: "Editar",
            onClick: (rowData) => {
              setShowDialog(true);
              setSelected(rowData);
            },
            tooltipOptions: {
              position: "right",
            },
          },
          {
            icon: "pi ri-tools-fill",
            tooltip: "Acceso",
            onClick: (rowData) => {
              setShowDialogUser(true);
              setSelected(rowData);
            },
            tooltipOptions: {
              position: "left",
            },
          },
        ],
      },
    ];

    const table = {
      Columns: columns,
      Data: Accesos,
      loading: loading
    };

    useEffect(() => {
      setTitlePage(getLabel(baseLang, "acceso", config.language));
      getInfo();
    }, [])


    return (
      <div>
        <Toast ref={toast} />
        <Card
          titulo={<div className='botones'>
            <h3>{getLabel(baseLang, "acceso", config.language)}</h3>
            <Button icon='pi pi-refresh' onClick={getInfo} />
            <Button icon='pi pi-plus' severity='success' onClick={() => {
                setShowDialog(true);
                setSelected(null);
            }} />
          </div>}
          contenido={<div className='pt-4' style={{ height: '90vh' }}>
            <AgGrid table={table} />
          </div>}
        />

        {showDialog && <AccesosUsersCrud toast={toast} accesosDialog={showDialog} datos={selected} setAccesosDialog={setShowDialog} getAccesos={getInfo} modo={selected ? "Editar" : "Crear"} />}
        {showDialogUser && <AccesosUser toast={toast} showDialogUser={showDialogUser} selected={selected} setShowDialogUser={setShowDialogUser} getAccesos={getInfo} />}

      </div>
    )
}

export default AccesosScreen